import { session } from '@/utils';

export const SUMMARY_KEY = '$_$summary';

export const NO_PERMISSION_STORE = 'NO_PERMISSION_STORE';

export const DEFAULT_NAVIGATOR_LOCAL = window.navigator.language;

export const IS_DEV = process.env.NODE_ENV === 'development';

export const IS_SIM = window?.location?.host?.indexOf('sim') === 0;

export const IS_PRE = window?.location?.host?.indexOf('pre-') === 0;

export const IS_PRO = window?.location?.host?.indexOf('gattaran') === 0;

export const IS_SODA = process.env.VUE_APP_BUILD_ENV === 'soda';

export const IS_PRE_API = session.getItem('preDebug') === 'true';

export const ReadStatus = {
  UN_READ: 1,
  IS_READ: 2,
};
